<template>
  <div class="trustees">
    <div class="mb-3">
      <div v-if="currentPlanId">
        <span class="currentPlanName">{{ currentPlanName }}</span>
      </div>
      <div v-else>
        <v-alert type="info" outlined dense> Please, select a plan first to view data </v-alert>
      </div>
    </div>
    <v-row v-if="currentPlanId">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="trusteesList"
          item-key="TrusteeId"
          :items-per-page="-1"
          :footer-props="{ 'items-per-page-options': [15, 20, 30, 50, 100, -1] }"
          :loading="loading"
          loading-text="Loading Trustees list..."
          :calculate-widths="true"
          class="searchResults"
          dense
        >
          <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item, value }">
            {{ formatTableEl(item, value, header.format) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Utils from '@/utils.js';

export default {
  components: {},
  name: 'Trustees',

  data() {
    return {
      loading: false,
      plansList: [],
      headers: [
        { text: 'Transaction date', value: 'TransactionDate', format: '{0:d}' },
        { text: 'Type', value: 'Type' },
        { text: 'Reference', value: 'Reference' },
        { text: 'Description', value: 'Description' },
        { text: 'Name', value: 'Name' },
        { text: 'Value', value: 'Value', align: 'right', format: '{0:#,###,##0.00}' },
        { text: 'Units', value: 'Units', align: 'right', format: '{0:#,###,##0.00}' },
        { text: 'Reconciled', value: 'Reconciled' },
      ],
      trusteesList: [],
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    currentPlanName() {
      if (this.currentPlanId && this.plansList && this.plansList.length > 0) {
        const plan = this.plansList.find((x) => {
          return x.Id == this.currentPlanId;
        });
        if (plan) {
          return plan.ShortName;
        }
      }

      return '';
    },
  },

  watch: {
    memberId() {
      this.getTrusteesList();
    },
  },

  created() {
    //this.getHeaders('Trustees');
    this.getTrusteesList();
    this.getPlansList();
  },

  mounted: function () {
    this.$root.currentPage = 'Trustees';
  },

  methods: {
    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },
    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },
    async getTrusteesList() {
      this.loading = true;
      try {
        const response = await this.$api.get(
          '/Trustee/GetTrusteeData?planId=' + this.currentPlanId
        );
        this.trusteesList = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async getHeaders(formName) {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=${formName}&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        } else {
          throw new Error('Unable to fetch table headers');
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    async getPlansList() {
      try {
        const response = await this.$api.get('/plans/getplanlist');

        if (!response.data.length) {
          const msg = 'Unable to load plans';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        if (response.data && response.data.length) this.plansList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>

<style>
.trustees {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}

.trustees .currentPlanName {
  background-color: #cbe9ff;
  padding: 8px;
  color: #4a1cd4;
}

.trustees .theme--light.v-data-table tbody tr {
  cursor: auto;
}
</style>
